import { loanInfoConstants } from "../_constants";
import { userService } from "../_services/user.service";

const bannerInitialState = {
    showBanner: false, bannerData: {}, englishBanner: '', spanishBanner: '', banner: '', showPaymentButton: false
};

export function banner(state = bannerInitialState, action) {

    switch (action.type) {
        case loanInfoConstants.BANNER_DATA_LOADED:
            var banner = JSON.parse(action.bannerData);
            var userLang = userService.getUserLanguage();
            var bannertext = "";

            if (userLang.toLowerCase() === "es") {
                bannertext = banner.spanish;
            }
            else {
                bannertext = banner.english;
            }

            return { ...state, bannerData: action.bannerData, showBanner: banner.showBanner, englishBanner: banner.english, spanishBanner: banner.spanish, banner: bannertext, showPaymentButton: banner.showPaymentButton };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/banner.reducer.js